import { render, staticRenderFns } from "./FormatSetReferencesSelector.vue?vue&type=template&id=7aa7fcf5&scoped=true&"
import script from "./FormatSetReferencesSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatSetReferencesSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatSetReferencesSelector.vue?vue&type=style&index=0&id=7aa7fcf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa7fcf5",
  null
  
)

export default component.exports